import { keycloakApi } from '@/services/keycloakApi'

export async function startKeycloakLogin(): Promise<void> {
  const redirectUri = `${window.location.origin}/auth/callback`
  const response = await keycloakApi.initiateLogin(redirectUri)

  sessionStorage.setItem('keycloak_state', response.state)
  sessionStorage.setItem('keycloak_code_verifier', response.code_verifier)
  sessionStorage.setItem('keycloak_redirect_uri', response.redirect_uri)
  if (response.signature) {
    sessionStorage.setItem('keycloak_signature', response.signature)
  } else {
    sessionStorage.removeItem('keycloak_signature')
  }
  if (response.ts) {
    sessionStorage.setItem('keycloak_ts', String(response.ts))
  } else {
    sessionStorage.removeItem('keycloak_ts')
  }

  window.location.assign(response.auth_url)
}
